import Image from 'next/image';
import Icon from './play_arrow.svg?url';
import type { SvgImageProps } from '../_type';

export const PlayWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={Icon} alt={alt} {...props} />
);
